'use strict';
(function(){
    var testimonialRoot = document.getElementById('la-testimonial-carousel');
    if (testimonialRoot) {
      var testimonialViewport = testimonialRoot.querySelector('.la-testimonial-viewport');
      var testimonialTrack = testimonialRoot.querySelector('.la-testimonial-track');
      var testimonialPrev = testimonialRoot.querySelector('.la-testimonial-prev');
      var testimonialNext = testimonialRoot.querySelector('.la-testimonial-next');
      var testimonialDots = testimonialRoot.querySelector('.la-testimonial-dots');
      var testimonialOriginals = Array.prototype.slice.call(testimonialTrack.children);
      var testimonialCount = testimonialOriginals.length;
      var testimonialCurrent = 1;
      var testimonialLocked = false;
      var testimonialStartX = 0;
      var testimonialDeltaX = 0;
      var testimonialDragging = false;
      var testimonialAutoplayTimer = null;
      var testimonialHovering = false;
      var testimonialFocused = false;
      var testimonialReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      testimonialTrack.insertBefore(testimonialOriginals[testimonialCount - 1].cloneNode(true), testimonialTrack.firstChild);
      testimonialTrack.appendChild(testimonialOriginals[0].cloneNode(true));
      var testimonialSlides = Array.prototype.slice.call(testimonialTrack.children);

      testimonialOriginals.forEach(function (_, index) {
        var dot = document.createElement('button');
        dot.className = 'la-testimonial-dot';
        dot.type = 'button';
        dot.setAttribute('aria-label', document.querySelector('.la-short-root')?.lang==='en' ? 'View testimonial '+(index+1) : '查看第' + (index + 1) + '则顾客见证');
        dot.addEventListener('click', function () { moveTestimonial(index + 1); scheduleTestimonialAutoplay(); });
        testimonialDots.appendChild(dot);
      });

      function testimonialLogicalIndex() { return (testimonialCurrent - 1 + testimonialCount) % testimonialCount; }
      function updateTestimonialCurrent() {
        testimonialSlides.forEach(function (slide, index) {
          var active = index === testimonialCurrent;
          slide.classList.toggle('is-current', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        Array.prototype.slice.call(testimonialDots.children).forEach(function (dot, index) {
          dot.classList.toggle('is-active', index === testimonialLogicalIndex());
        });
      }
      function placeTestimonial(animate) {
        var mobile = window.innerWidth <= 660;
        var gap = mobile ? 10 : 18;
        var slideWidth = mobile ? testimonialViewport.clientWidth * .82 : Math.min(testimonialViewport.clientWidth * .46, 520);
        testimonialSlides.forEach(function (slide) { slide.style.width = slideWidth + 'px'; });
        testimonialTrack.classList.toggle('no-transition', !animate);
        var x = (testimonialViewport.clientWidth - slideWidth) / 2 - testimonialCurrent * (slideWidth + gap);
        testimonialTrack.style.transform = 'translate3d(' + x + 'px,0,0)';
        updateTestimonialCurrent();
      }
      function moveTestimonial(index) {
        if (testimonialLocked) return;
        if (index === testimonialCurrent) return;
        testimonialLocked = true;
        testimonialCurrent = index;
        placeTestimonial(true);
      }
      function stepTestimonial(direction) { moveTestimonial(testimonialCurrent + direction); }
      function stopTestimonialAutoplay() {
        if (testimonialAutoplayTimer) window.clearTimeout(testimonialAutoplayTimer);
        testimonialAutoplayTimer = null;
      }
      function scheduleTestimonialAutoplay() {
        stopTestimonialAutoplay();
        if (window.innerWidth <= 660 || testimonialReducedMotion || testimonialHovering || testimonialFocused || testimonialDragging || document.hidden) return;
        testimonialAutoplayTimer = window.setTimeout(function () {
          if (!testimonialLocked) stepTestimonial(1);
          scheduleTestimonialAutoplay();
        }, 5000);
      }

      testimonialTrack.addEventListener('transitionend', function () {
        if (testimonialCurrent === 0) {
          testimonialCurrent = testimonialCount;
          placeTestimonial(false);
        } else if (testimonialCurrent === testimonialCount + 1) {
          testimonialCurrent = 1;
          placeTestimonial(false);
        }
        testimonialLocked = false;
      });
      testimonialPrev.addEventListener('click', function () { stepTestimonial(-1); scheduleTestimonialAutoplay(); });
      testimonialNext.addEventListener('click', function () { stepTestimonial(1); scheduleTestimonialAutoplay(); });
      testimonialRoot.addEventListener('mouseenter', function () { testimonialHovering = true; stopTestimonialAutoplay(); });
      testimonialRoot.addEventListener('mouseleave', function () { testimonialHovering = false; scheduleTestimonialAutoplay(); });
      testimonialRoot.addEventListener('focusin', function () { testimonialFocused = true; stopTestimonialAutoplay(); });
      testimonialRoot.addEventListener('focusout', function () { window.setTimeout(function () { testimonialFocused = testimonialRoot.contains(document.activeElement); scheduleTestimonialAutoplay(); }, 0); });
      document.addEventListener('visibilitychange', function () { if (document.hidden) stopTestimonialAutoplay(); else scheduleTestimonialAutoplay(); });
      testimonialRoot.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') stepTestimonial(-1);
        if (event.key === 'ArrowRight') stepTestimonial(1);
      });
      testimonialViewport.addEventListener('pointerdown', function (event) {
        if (testimonialLocked) return;
        testimonialDragging = true;
        testimonialStartX = event.clientX;
        testimonialDeltaX = 0;
        testimonialViewport.classList.add('is-dragging');
        stopTestimonialAutoplay();
        testimonialViewport.setPointerCapture(event.pointerId);
      });
      testimonialViewport.addEventListener('pointermove', function (event) {
        if (!testimonialDragging) return;
        testimonialDeltaX = event.clientX - testimonialStartX;
      });
      testimonialViewport.addEventListener('pointerup', function () {
        if (!testimonialDragging) return;
        testimonialDragging = false;
        testimonialViewport.classList.remove('is-dragging');
        if (Math.abs(testimonialDeltaX) >= 55) stepTestimonial(testimonialDeltaX < 0 ? 1 : -1);
        scheduleTestimonialAutoplay();
      });
      testimonialViewport.addEventListener('pointercancel', function () {
        testimonialDragging = false;
        testimonialViewport.classList.remove('is-dragging');
        scheduleTestimonialAutoplay();
      });
      var testimonialResizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(testimonialResizeTimer);
        testimonialResizeTimer = setTimeout(function () { placeTestimonial(false); scheduleTestimonialAutoplay(); }, 120);
      });
      testimonialRoot.tabIndex = 0;
      placeTestimonial(false);
      scheduleTestimonialAutoplay();
    }


})();

(function(){
'use strict';
const shortEnglish=document.querySelector('.la-short-root')?.lang==='en';
const offers={1:{price:92,days:15,contents:'750ml补液 + 30粒胶囊'},3:{price:246,days:45,contents:'3瓶750ml补液 + 90粒胶囊'},6:{price:468,days:90,contents:'6瓶750ml补液 + 180粒胶囊'}};
function selectOffer(quantity){
  const offer=offers[quantity];
  document.getElementById('offer-sets').textContent=shortEnglish?quantity+(quantity===1?' set':' sets'):quantity+'套';
  document.getElementById('offer-days').textContent=shortEnglish?offer.days+'-day supply':'可服用'+offer.days+'天';
  document.getElementById('offer-price').textContent=offer.price;
  document.getElementById('offer-contents').textContent=shortEnglish?(quantity===1?'750 ml liquid tonic + 30 capsules':quantity+' × 750 ml liquid tonic + '+quantity*30+' capsules'):offer.contents;
  document.getElementById('short-order-variant').value={1:'48321241284761',3:'48321240826009',6:'48967600242841'}[quantity];
  document.getElementById('short-order-button').textContent=shortEnglish?'Add to Cart — '+quantity+(quantity===1?' set':' sets')+' S$'+offer.price:'加入购物车 — '+quantity+'套 S$'+offer.price;
  const msg='你好，我想订购'+quantity+'套雄液补品，价格S$'+offer.price+'。请协助安排送货与货到付款。';
  document.getElementById('order-whatsapp').href='https://wa.me/6588269998?text='+encodeURIComponent(msg);
}
document.querySelectorAll('input[name="package"]').forEach(input=>input.addEventListener('change',()=>selectOffer(Number(input.value))));
selectOffer(1);

document.getElementById('short-faq-list').addEventListener('click',function(event){
  const button=event.target.closest('.bho-faq-q');
  if(!button)return;
  const selected=button.closest('.bho-faq-item');
  const wasOpen=selected.classList.contains('is-open');
  this.querySelectorAll('.bho-faq-item').forEach(function(item){
    const open=item===selected&&!wasOpen;
    item.classList.toggle('is-open',open);
    item.querySelector('.bho-faq-q').setAttribute('aria-expanded',String(open));
    item.querySelector('.bho-faq-a').setAttribute('aria-hidden',String(!open));
    item.querySelector('.bho-faq-icon').textContent=open?'−':'+';
  });
});

})();
document.querySelectorAll('.la-short-root .bho-acc-hdr').forEach(function(header){header.addEventListener('click',function(){var item=header.closest('.bho-acc-item');var open=item.classList.toggle('bho-acc-open');header.setAttribute('aria-expanded',String(open));});});